import createReactClass from "create-react-class";

export default function(dependencies) {

    var Honeypot = createReactClass({
        render() {
            return <div className="lz-input-wrapper" >
                <label>Alder</label>
                <div className="lz-input" >
                    <div className="lz-checkmark"><i className="fa fa-check"></i></div>
                    <input type="text" onChange={this.onChange} />
                    <span className="lz-input-bar"></span>
                </div>
            </div>;
        },
        onChange(event) {
            this.props.field.state.value = event.target.value;
            this.props.onUpdate();
        }
    });

    return {
        html: Honeypot,
        config: {
            invisible: true,
        },
    };

};
